import React from 'react'
import { Dropdown, FormDropdown, StrictFormDropdownProps } from 'semantic-ui-react'
import { Field, WrappedFieldProps } from 'redux-form'
import { ReduxFieldProps, SemanticFieldProps, mapErrorProps } from './SemanticField'
import { useRegisterTab } from './Tabs/TabItem'
import { useTranslation } from 'react-i18next'

// We need to manually add style since it's used in a bunch of places
// The style gets spread onto most of the child components of the dropdown so it can't just be replaced by a className
export interface StrippedDropdownProps extends Omit<StrictFormDropdownProps, 'onChange'> {
  style?: React.CSSProperties
  autoComplete?: string
}

export type ReduxDropdownProps = SemanticFieldProps<StrippedDropdownProps>
export type InnerFieldProps = ReduxFieldProps<StrippedDropdownProps>

// asDropdown is a helper that will render a semantic dropdown (without field wrappers etc.)
// it should be like `as={s}`
export const asDropdown = (props: any) => {
  const { control, ...newProps } = props
  return <Dropdown {...newProps} />
}

const Component = (props: WrappedFieldProps & StrictFormDropdownProps) => {
  const { input, meta, label, ...rest } = props
  const { t } = useTranslation()

  return (
    <FormDropdown
      {...input}
      onChange={(_, { value }) => input.onChange(value)}
      onBlur={_ => input.onBlur(undefined)}
      onFocus={e => input.onFocus(e as any)}
      {...rest}
      searchInput={{ autoComplete: 'none', name: `${input.name}.SearchInput` }}
      {...mapErrorProps(meta, label)}
      noResultsMessage={t('global.search_no_results_found')}
    />
  )
}

export const ReduxDropdown: React.FC<ReduxDropdownProps> = props => {
  useRegisterTab(props.name)

  return <Field component={Component} {...props} />
}

ReduxDropdown.displayName = 'ReduxDropdown'

export default React.memo(ReduxDropdown)
